var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.7094 18.2866L14.3086 12.8858C15.3607 11.5331 15.992 9.83968 15.992 7.99599C15.992 3.57715 12.4048 0 7.99599 0C3.58717 0 0 3.57715 0 7.99599C0 12.4148 3.57715 15.992 7.99599 15.992C9.83968 15.992 11.5431 15.3607 12.8958 14.3086L18.2966 19.7094C18.497 19.9098 18.7475 20 19.008 20C19.2685 20 19.519 19.8998 19.7194 19.7094C20.1002 19.3186 20.1002 18.6774 19.7094 18.2866ZM2.00401 7.99599C2.00401 4.68938 4.68938 2.00401 7.99599 2.00401C11.3026 2.00401 13.988 4.68938 13.988 7.99599C13.988 11.3026 11.3026 13.988 7.99599 13.988C4.68938 13.988 2.00401 11.2926 2.00401 7.99599Z"}));
}

IconSearch.defaultProps = {"viewBox":"0 0 21 20","fill":"none"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
